import { render } from "./IconArrow.vue?vue&type=template&id=38a699e4&scoped=true"
import script from "./IconArrow.vue?vue&type=script&lang=ts"
export * from "./IconArrow.vue?vue&type=script&lang=ts"

import "./IconArrow.vue?vue&type=style&index=0&id=38a699e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38a699e4"

export default script